import React, { useState } from 'react';
import RemindIcon from '@rsuite/icons/legacy/Remind';
import { Icon } from '@rsuite/icons';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';
import {
  Input,
  InputGroup,
  Table,
  Button,
  CheckPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Message,
  Modal,
  Col,
  useToaster,
  Form,
  FlexboxGrid,
  Container,
  SelectPicker,
  IconButton
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';

const { Column, HeaderCell, Cell } = Table;

const AddBuyer = () => {

  // For Main Table Start
  const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
    const editing = rowData.status === 'EDIT';
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <input
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );
  };
  const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
      <Cell {...props} style={{ padding: '6px' }}>
        <Stack spacing={5}>
          <Button
            appearance="subtle"
            active
            onClick={() => {
              onClick(rowData.id);
            }}
          >
            {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
          </Button>
          <IconButton size="md" appearance="subtle" active icon={< TrashIcon />} onClick={() => handleDeleteRow(rowData.id)} />
        </Stack>
      </Cell>
    );
  };
  // For Main Table End

  // For Second Table Start
  const EditableCell1 = ({ rowData, dataKey, onChange, ...props }) => {
    const editing = rowData.status === 'EDIT';
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <input
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );
  };
  const ActionCell1 = ({ rowData, dataKey, onClick, ...props }) => {
    return (
      <Cell {...props} style={{ padding: '6px' }}>
        <Stack spacing={5}>
          <Button
            appearance="subtle"
            active
            onClick={() => {
              onClick(rowData.id);
            }}
          >
            {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
          </Button>
          <IconButton size="md" appearance="subtle" active icon={< TrashIcon />} onClick={() => handleDeleteRow1(rowData.id)} />
        </Stack>
      </Cell>
    );
  };
  // For Second Table End


  const toaster = useToaster();
  const [placement, setPlacement] = useState('topEnd');
  const message = (
    <Message showIcon type="success" closable>
      success: Saved Successfully.
    </Message>
  );

  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState();
  const handleOpen = value => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => {
    toaster.push(message, { placement })
    setOpen(false)
  }
  const handleClose3 = () => setOpen(false);

  const [open1, setOpen1] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpen1 = value => {
    setSize1(value);
    setOpen1(true);
  };
  const handleClose1 = () => setOpen1(false);

  // For Main Table Function Start
  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], tableData1);
    nextData.find(item => item.id === id)[key] = value;
    setTableData1(nextData);
  };
  const handleEditState = id => {
    const nextData = Object.assign([], tableData1);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setTableData1(nextData);
  };
  const handleDeleteRow = (id) => {
    const newData = tableData1.filter((row) => row.id !== id);
    setTableData1(newData);
  };
  // For Main Table Function End

  // For Second Table Function Start
  const handleChange1 = (id, key, value) => {
    const nextData = Object.assign([], tableData);
    nextData.find(item => item.id === id)[key] = value;
    setTableData(nextData);
  };
  const handleEditState1 = id => {
    const nextData = Object.assign([], tableData);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setTableData(nextData);
  };
  const handleDeleteRow1 = (id) => {
    const newData = tableData.filter((row) => row.id !== id);
    setTableData(newData);
  };
  // For Second Table Function End



  const data1 = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
    item => ({ label: item, value: item })
  );

  const data3 = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
    item => ({ label: item, value: item })
  );

  //   add table start 1
  const [tableData, setTableData] = useState([]);
  function handleAddRow() {
    if (input == "") {
      handleOpen2();
    } else {
      const newRow = {
        id: tableData.length + 1,
        name: input
      };
      setTableData([...tableData, newRow]);
      setInput('');
    }
  }
  const [input, setInput] = useState('')
  function handleInputChange(event) {
    setInput(event.target.value);
  }

  //   add table end 1
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  //   main add row start 
  const [companyname, setCompanyname] = useState('');
  const [buyername, setBuyername] = useState('');
  const [country, setCountry] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [mnumber, setMnumber] = useState('');
  const [merchant, setMerchant] = useState('');
  const [tableData1, setTableData1] = useState([]);
  function handleInputChange1(value, setValue) {
    setValue(value);
  }
  function handleAddRow1() {
    if (companyname == "") {
      handleOpen2();
    } else {
      const newRow = {
        id: tableData1.length + 1,
        companyname: companyname,
        buyername: buyername,
        country: country,
        email: email,
        address: address,
        mnumber: mnumber,
        merchant: merchant
      };
      setTableData1([...tableData1, newRow]);
      setCompanyname('');
      setBuyername('');
      setCountry('');
      setEmail('');
      setAddress('');
      setMnumber('');
      setMerchant('');
      handleClose();
    };
  };
  // main add row end 

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar " justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start'>
              <h3 className="title">Buyer</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Buyer</Breadcrumb.Item>

              </Breadcrumb>
            </Stack>

            <Stack spacing={5}>
              <SelectPicker data={data1} size="xs" appearance="default" placeholder="Buyer Name" style={{ width: 200 }} />
              <Button appearance="default" active >
                More
              </Button>
            </Stack>
          </Stack>

          <Stack direction='column' alignItems='flex-end' spacing={24}>
            <Stack direction='row' spacing={5}>
              <Button appearance="default" active onClick={() => handleOpen1('md')}>
                Add Company
              </Button>
              <Button color="cyan" appearance="primary" onClick={() => handleOpen('md')}>
                Add Buyer
              </Button>
            </Stack>
            <Stack spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>

          </Stack>


        </Stack>
        <Divider className='divide' />


        <Panel>
          <Table height={420} data={tableData1}
            rowHeight={60}
            rowKey="id"
            onRowClick={(tableData1) => console.log(tableData1)}
          >
            <Column width={100}>
              <HeaderCell>ID</HeaderCell>
              <Cell dataKey="id" />
            </Column>

            <Column width={200}>
              <HeaderCell>Company Name</HeaderCell>
              <EditableCell dataKey="companyname" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={200}>
              <HeaderCell>Buyer Name</HeaderCell>
              <EditableCell dataKey="buyername" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={200}>
              <HeaderCell>Country</HeaderCell>
              <EditableCell dataKey="country" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={300}>
              <HeaderCell>Email</HeaderCell>
              <EditableCell dataKey="email" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={200}>
              <HeaderCell>Address</HeaderCell>
              <EditableCell dataKey="address" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={200}>
              <HeaderCell>Contact No.</HeaderCell>
              <EditableCell dataKey="mnumber" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={200}>
              <HeaderCell>Merchant</HeaderCell>
              <EditableCell dataKey="merchant" rowData={undefined} onChange={handleChange} />
            </Column>

            <Column width={100} fixed="right">
              <HeaderCell>Action</HeaderCell>
              <ActionCell dataKey="id" onClick={handleEditState} rowData={undefined} />
            </Column>
          </Table>
        </Panel>
        {/* first modal start */}
        <Modal size={size} open={open} onClose={handleClose} backdrop="static">
          <Modal.Header>
            <Modal.Title><b>Add Buyer</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Company Name</Form.ControlLabel>
                    <Input placeholder="Company Name" value={companyname} onChange={value => handleInputChange1(value, setCompanyname)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <Input placeholder="Buyer Name" value={buyername} onChange={value => handleInputChange1(value, setBuyername)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Country</Form.ControlLabel>
                    <SelectPicker placeholder="Country" value={country} onChange={value => handleInputChange1(value, setCountry)} data={data3} block />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Input placeholder="Email" value={email} onChange={value => handleInputChange1(value, setEmail)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Address</Form.ControlLabel>
                    <Input placeholder="Address" value={address} onChange={value => handleInputChange1(value, setAddress)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Contact No.</Form.ControlLabel>
                    <Input placeholder="Contact No." value={mnumber} onChange={value => handleInputChange1(value, setMnumber)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Merchant</Form.ControlLabel>
                    <SelectPicker placeholder="Merchant" value={merchant} onChange={value => handleInputChange1(value, setMerchant)} data={data3} block />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent='space-between'>
              <Button onClick={handleClose3} appearance="ghost" color='cyan'>
                Cancel
              </Button>
              <Button onClick={handleAddRow1} appearance="primary" color='cyan'>
                Save
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {/* first modal end */}

        {/* second modal start */}
        <Modal size={size1} open={open1} onClose={handleClose1} backdrop="static">
          <Modal.Header>
            <Modal.Title><b>Add Company</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack justifyContent='space-between'>
              <input className='rs-input' value={input} onChange={handleInputChange} />
              <Button onClick={handleAddRow} active>Add Company</Button>
            </Stack>
            <Table data={tableData}
              height={500}
              rowHeight={60}
              rowKey="id"
              onRowClick={(tableData) => console.log(tableData)}
            >
              <Table.Column width={100} align="center" fixed>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.Cell dataKey="id" />
              </Table.Column>

              <Table.Column width={300}>
                <Table.HeaderCell>Company Name</Table.HeaderCell>
                <EditableCell1 dataKey="name" rowData={undefined} onChange={handleChange1} />
              </Table.Column>

              <Column width={100} fixed="right">
                <HeaderCell>Action</HeaderCell>
                <ActionCell1 dataKey="id" onClick={handleEditState1} rowData={undefined} />
              </Column>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent='space-between'>
              <Button onClick={handleClose1} appearance="ghost" color='cyan'>
                Cancel
              </Button>
              <Button onClick={handleClose1} appearance="primary" color='cyan'>
                Save
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {/* second modal end */}
        <Modal backdrop="static" role="alertdialog" open={open2} onClose={handleClose2} size="xs">
          <Modal.Body>
            <RemindIcon style={{ color: '#ffb300', fontSize: 20 }} />
            Please Enter The Company Name!
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose2} appearance="primary">
              Ok
            </Button>
            <Button onClick={handleClose2} appearance="subtle">
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
      </Container>
    </>
  );
};

export default AddBuyer;